import React,{useState,useEffect}from 'react'
import Main from '../../cpn/Main'
import { Table,Space,Modal,message,Flex} from 'antd';
import { useNewsTypeDelMutation, useNewsTypeListQuery, } from '../../store/ReactWebSiteApi';
import NewsTypeEdit from './NewsTypeEdit';
import NewsTypeCheck from './NewsTypeCheck';
import NewsTypeAdd from './NewsTypeAdd';
function NewsTypeList() {
    const {confirm} = Modal; 
    const [submitDel] = useNewsTypeDelMutation()
    const {data,isSuccess} = useNewsTypeListQuery({ent_e_id:localStorage.getItem('e_id')})
    const [list, setList] = useState();
    useEffect(() => {
        if(isSuccess){            
            if(data.Status==='success'){
                const newArr = data.Result.map(item => {
                    const {ent_id:key,ent_name,ent_uname,ent_ctime,ent_update_ctime,ent_update_uname,news_num} = item;
                    return item = {key,ent_name,ent_uname,ent_ctime,ent_update_ctime,ent_update_uname,news_num}
                })                
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.ent_ctime;
                    let bTimeString = b.ent_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
        }
    }, [data, isSuccess])      
    const columns = [
        {
            key: 'id',
            title: '编号',
            dataIndex: 'key'
        },
       
        {
            key: 'type',
            title: '名称',
            dataIndex: 'ent_name',
            render:(_,record) => {
                return <NewsTypeCheck 
                            text={record.ent_name}
                            ent_id={record.key}
                        />
            }
        },                           
        {
            key: 'num',
            title: '新闻数量',
            dataIndex: 'news_num',
        },       
        {
            key: 'time',
            title: '操作记录',
            render: (_,record) => {
                return <>
                    <div>新建时间：{record.ent_ctime + record.ent_uname}</div>
                    <div>修改时间：</div>
                </>
            }
        },
        {
            key: 'action',
            title: '操作',
            render: (_, record) => {
                return <>
                    <Space>                        
                        <NewsTypeEdit ent_id={record.key} />
                        {!record.news_num && <a onClick={() => {
                            confirm({
                                title: '确定删除吗?',
                                content: '删除后不能恢复',
                                okText: '确认',
                                okType: 'danger',
                                cancelText: '取消',
                                onOk() {
                                    submitDel({ent_id:record.key}).then((res) => {
                                        if (res.data.Status === 'success') {
                                            message.info('删除成功！');
                                        }
                                        if (res.data.Status === "fail") {
                                            message.error('删除失败！'+res.data.Message)
                                        }
                                    })
                                },
                                onCancel() {
                                console.log('Cancel');
                                },
                            });
                        }}>删除</a>}
                    </Space>
                </>
            }
        },
    ]
    
    return (
        <Main  selectedKeys={['/NewsTypeList']} >
            <Flex justify='flex-end'>
                <NewsTypeAdd />
            </Flex>
            <Table columns={columns} style={{marginTop:'20px'}} dataSource={list}></Table> 
        </Main>
    )
}

export default NewsTypeList